<form class="qualification-tab-form" [formGroup]="QualificationTab" class="mt-5"  style="margin-left: 100px; margin-right: 100px">
  <input type="hidden" formControlName="ExemptionFilingRequestId">
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-form-field class="qualification-type-width">
      <mat-label class="boldlabel">Qualification Type</mat-label>
      <mat-select formControlName="qualificationType">
        <mat-option *ngFor="let rl of QualificationTypes" [value]="rl.id">
          {{rl?.description}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-form-field class="entity-control-width">
      <mat-label class="boldlabel">Entity Control #</mat-label>
      <input matInput placeholder="Entity Control" formControlName="entityControlNumber">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-label class="business-entity-name">Business Entity Name</mat-label>
    <mat-label class="entity-name">{{ QualificationTab.controls["filingEntityName"].value }}</mat-label>
  </div>
  <div fxLayout="row" fxLayoutGap="50px" class="applicant-background-color">
    <span class='applicant-span'>Applicant</span>
  </div>
  <ng-container *ngIf="!IsVerificationCorrection">
    <div fxLayout="row" fxLayoutGap="50px">
      <mat-form-field class="first-name-width">
        <mat-label class="boldlabel">First Name</mat-label>
        <input matInput placeholder="First Name" formControlName="firstName" value="">
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="50px">
      <mat-form-field class="first-name-width">
        <mat-label>Middle Name</mat-label>
        <input matInput placeholder="Middle Name" formControlName="middleName" value="">
      </mat-form-field>
  
    </div>
    <div fxLayout="row" fxLayoutGap="50px">
      <mat-form-field class="first-name-width">
        <mat-label class="boldlabel">Last Name</mat-label>
        <input matInput placeholder="Last Name" formControlName="lastName" value="">
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="50px">
      <div class="col-6">
      <mat-form-field class="first-name-width">
        <mat-label>Suffix</mat-label>
        <input matInput autocomplete="off" placeholder="Suffix" 
          formControlName="nameSuffix" value="">
      </mat-form-field>
      </div>
    </div>
    <div fxLayout="row" fxLayoutGap="50px">
      <div class="col-6">
      <mat-form-field  class="first-name-width">
        <mat-label style="color:darkred">Birth Date</mat-label>
        <input class="boldlabel" matInput [matDatepicker]="birthDatePicker" formControlName="birthDate"
          placeholder="Birth Date">
        <mat-datepicker-toggle  matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #birthDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
    </div>
    <div fxLayout="row" fxLayoutGap="50px">
      <div class="col-6">
      <mat-form-field class="first-name-width">
        <mat-label style="color:darkred" class="boldlabel">Last 4 SSN or SSA Control #</mat-label>
        <input matInput autocomplete="off" placeholder="Last 4 SSN or SSA Control #" mask='0000'
          formControlName="lastFourSocialSecurityNumber" value="">
      </mat-form-field>
    </div>
    </div>
    <div fxLayout="row" fxLayoutGap="50px">
        <mat-label style="color: red">{{verificationError}}</mat-label>
    </div>
  </ng-container>
  <ng-container *ngIf="IsVerificationCorrection">
    <div class="row">
      <div class="col-6">
        <mat-form-field class="first-name-width">
          <mat-label class="boldlabel">First Name</mat-label>
          <input matInput placeholder="First Name" formControlName="firstName" value="">
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="birth-date-width">
          <input class="boldlabel" matInput [matDatepicker]="birthDatePicker" formControlName="birthDate"
            placeholder="Date of Birth">
          <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #birthDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <mat-form-field class="first-name-width">
          <mat-label>Middle Name</mat-label>
          <input matInput placeholder="Middle Name" formControlName="middleName" value="">
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="birth-date-width">
          <mat-label class="boldlabel">Last 4 SSN or SSA Control #</mat-label>
          <input matInput autocomplete="off" placeholder="Last 4 SSN or SSA Control #" mask='0000'
            formControlName="lastFourSocialSecurityNumber" value="">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <mat-form-field class="first-name-width">
          <mat-label class="boldlabel">Last Name</mat-label>
          <input matInput placeholder="Last Name" formControlName="lastName" value="">
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="birth-date-width">
          <mat-label>Suffix</mat-label>
          <input matInput autocomplete="off" placeholder="Suffix" 
            formControlName="nameSuffix" value="">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <mat-form-field class="phone-width">
          <mat-label class="boldlabel">Phone</mat-label>
          <input matInput placeholder="(###) ###-####" mask='(000) 000-0000' formControlName="contactPhone" value="">
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="phone-extension-width">
          <mat-label>Phone Extension</mat-label>
          <input matInput placeholder="Phone Extension" formControlName="contactPhoneExtension" value="">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <mat-form-field class="email-width">
        <mat-label class="boldlabel">Email</mat-label>
        <input type="email" matInput placeholder="Email"
          formControlName="contactEmail" value="">
      </mat-form-field>
    </div>
    <div class="row">
      <div class="col-12">
      <mat-form-field class="email-width">
        <mat-label class="boldlabel">Confirm Email</mat-label>
        <input [errorStateMatcher]="matcher" type="email" matInput
          formControlName="confirmEmail" placeholder="Confirm Email" value="">
        <mat-error *ngIf="QualificationTab.hasError('notSame')">
          Emails do not match
        </mat-error>
      </mat-form-field>
      </div>
    </div>
  </ng-container>
</form>
